import type { JSX } from 'react';

type RemoveFromListIconProps = {
  className?: string;
};

const RemoveFromListIcon = (props: RemoveFromListIconProps): JSX.Element => {
  const { className } = props;
  return (
    <svg
      className={className || ''}
      viewBox="0 0 26 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.36353 4.36364H15.909"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.36353 10.5453H15.909"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.9091 16.3636H25"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.36368 16.3636H10.4546"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default RemoveFromListIcon;
